import { composeEntitiesListSelectors } from '@bp/admins-shared/features/entity';

import type { Preset } from '../../models';
import { getListState } from '../feature.selectors';

import type { IState } from './presets.reducer';

export const PRESETS_LIST_SELECTORS = composeEntitiesListSelectors<Preset, IState>(getListState);
